module.exports = __webpack_public_path__ + "static/media/11.cbdcb8e2.jpg";